import React from 'react'
import BackToHome from '../../components/back-to-home'
import { Link } from 'react-router-dom'
import bg1 from '../../assets/images/authentication.jpg'

export default function PageSignup2() {
  return (
    <>
     <BackToHome/> 

    <section className="bg-home d-flex align-items-center" style={{backgroundImage:`url(${bg1})`, backgroundPosition:'center'}}>
        <div className="bg-overlay bg-overlay-primary"></div>
        <div className="container">
            <div className="row justify-content-center">
                <div className="col-lg-5 col-md-7">
                    <div className="login_page bg-white rounded p-4">
                        <div className="text-center">
                            <h4 className="mb-3">Register Form</h4>  
                        </div>
                        <form className="login-form">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="mb-3">                                               
                                        <label className="form-label">First name <span className="text-danger">*</span></label>
                                        <input type="text" className="form-control" placeholder="First Name" name="s" required=""/>
                                    </div>
                                </div>
                                <div className="col-md-12">
                                    <div className="mb-3">                                                
                                        <label className="form-label">Last name <span className="text-danger">*</span></label>
                                        <input type="text" className="form-control" placeholder="Last Name" name="s" required=""/>
                                    </div>
                                </div>
                                <div className="col-md-12">
                                    <div className="mb-3">
                                        <label className="form-label">Email <span className="text-danger">*</span></label>
                                        <input type="email" className="form-control" placeholder="Email" name="email" required=""/>
                                    </div>
                                </div>
                                <div className="col-md-12">
                                    <div className="mb-3">
                                        <label className="form-label">Password <span className="text-danger">*</span></label>
                                        <input type="password" className="form-control" placeholder="Password" required=""/>
                                    </div>
                                </div>
                                <div className="col-md-12">
                                    <div className="mb-3">
                                        <div className="form-check">
                                            <input className="form-check-input" type="checkbox" value="" id="flexCheckDefault"/>
                                            <label className="form-check-label" htmlFor="flexCheckDefault">I Accept <Link to="#" className="text-primary">Terms And Condition</Link></label>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-12">
                                    <button className="btn btn-primary w-100">Register</button>
                                </div>
                                <div className="mx-auto">
                                    <p className="mb-0 mt-4"><small className="text-dark me-2">Already have an account ?</small> <Link to="/page-login-2" className="text-dark fw-bold">Sign in</Link></p>
                                </div>
                            </div>
                        </form>
                    </div>
                </div> 
            </div>
        </div>
    </section>
    </>
  )
}
